import { Box } from '@mui/material'
import React from 'react'
import InfoTable from './InfoTable'
import { COMPANY_FIELDS } from '../utils/company'
import { Restaurant, RESTAURANT_FIELDS } from '../utils/restaurant'
import { formatCents } from '../utils/price'

const SERVICE_FEE_HINT = [
	'Zahlt der Kunde je Teilbestellung an Beyer Development',
	'Gepflegt in restaurant.service_fee_in_cents, nicht im Dashboard änderbar',
	'Gilt für Buchungen, die danach starten',
	'0 € = keine Servicegebühr',
]

const EditRestaurantBaseInfo = ({
	restaurant,
	isRoot,
}: {
	restaurant?: Restaurant | null
	isRoot?: boolean
}): JSX.Element => {
	const { restaurantEntries, companyEntries } = React.useMemo(() => {
		if (!restaurant) {
			return { restaurantEntries: [], companyEntries: [] }
		}
		const company = restaurant.company
		return {
			restaurantEntries: [
				...RESTAURANT_FIELDS.map((field) => ({
					label: field.label,
					value: restaurant[field.key],
					hint: field.hint,
				})),
				{
					label: 'Servicegebühr',
					value: formatCents(restaurant.serviceFeeInCents),
					hint: SERVICE_FEE_HINT,
				},
			],
			// Ohne Firma bleibt die Liste leer, damit die Karte den emptyHint zeigt statt lauter „-".
			companyEntries: !company
				? []
				: COMPANY_FIELDS.map((field) => ({
						label: field.label,
						value: company[field.key],
						hint: field.hint,
				  })),
		}
	}, [restaurant])

	return (
		<Box maxWidth="100%" display="flex" alignItems="flex-start" gap="1.5rem">
			{isRoot ? (
				<Box flex={1} minWidth={0}>
					<InfoTable
						title="Unternehmen"
						entries={companyEntries}
						emptyHint="Diesem Restaurant ist keine Firma zugeordnet. Ohne Firma lassen sich weder Verträge noch Menübestätigung oder Stripe-Onboarding versenden, und das Restaurant kann nicht aktiv werden — die USt-IdNr. bzw. Steuernummer hängt an der Firma."
					/>
				</Box>
			) : null}
			<Box flex={1} minWidth={0}>
				<InfoTable title="Restaurant" entries={restaurantEntries} />
			</Box>
		</Box>
	)
}

export default EditRestaurantBaseInfo
